import Vue from "vue";
import L from "leaflet";
import axios from "axios";
import VueAxios from "vue-axios";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import CenteredLoader from "./components/global/CenteredLoader";

import "./assets/styles.scss";
import "leaflet/dist/leaflet.css";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";

Vue.config.productionTip = false;

Vue.use(L);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueAxios, axios);
Vue.component("centered-loader", CenteredLoader);

if (sessionStorage.user) {
  store.commit("login", JSON.parse(sessionStorage.user));

  
  axios.defaults.headers.common['Authorization']= `Bearer ${sessionStorage.token}`;
}

new Vue({
  data: {
    displaybuttons: true,
    globalpolygons: [],
    globalgrid: [],
    globalgrid_temp: [],
    concealgrid: false,
    curlayer: undefined
  },
  router,
  store,
  provide: function() {
    return {
      eventBus: new Vue()
    };
  },
  render: h => h(App)
}).$mount("#app");
